import React, { Component } from "react";
import "./TextInput.less";

class TextInput extends Component {
  render() {
    const { label, name, value, onChange, required = false, error } = this.props;

    return (
      <div className="text-input">
        <label htmlFor={name} className={required ? "required" : ""}>
          {required && <span className="text-input__required">*</span>} {label}
        </label>
        <input
          name={name}
          type="text"
          value={value}
          onChange={onChange}
          className={error ? "text-input__error" : ""}
        />
        {error && <p className="text-input__error-message">{error}</p>}
      </div>
    );
  }
}

export default TextInput;